import React from 'react'

import { makeStyles } from '@material-ui/styles'

// Libs
import clsx from 'clsx'

// Utils
import {
  formatPrice,
  formatToPercentage,
  safeDivision
} from '../../../utils/format'
import {
  FUTURE_SALES_MESSAGE,
  getDisabledFieldMessage,
  getSalesDataDisabledReason,
  isFieldDisabled
} from '../../../utils/reportDisabledFields'
import { UnavailableValue } from 'components/UnavailableValue'

// Material UI
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Avatar,
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText
} from '@material-ui/core'

import {
  AttachMoney as AttachMoneyIcon,
  Timeline as TimelineIcon,
  ShoppingCart as ShoppingCartIcon,
  Loyalty as LoyaltyIcon,
  InsertChart as InsertChartIcon
} from '@material-ui/icons'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(1),
    margin: theme.spacing(2),
    minWidth: 300
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  card: {
    transition: 'all .2s ease-in-out',
    '&:hover': {
      transform: 'scale(1.08)'
    },
    cursor: 'pointer'
  },
  avatar: {
    justifyContent: 'center',
    width: '100px',
    height: '100px',
    marginBottom: theme.spacing(1)
  }
}))

export const GridStoresTable = ({
  store,
  handleSelectStore,
  disabledFields = {}
}) => {
  const classes = useStyles()
  const projectionSoldReason = disabledFields.projection?.sold ||
    (store.hasInputs === false ? 'NO_SALES_RECORDS' : undefined)
  const mainGoalReason = disabledFields.metric?.mainGoal
  const salesDisabledReason = getSalesDataDisabledReason(disabledFields)
  const salesDisabled = isFieldDisabled(salesDisabledReason)
  const renderSalesValue = renderValue => salesDisabled
    ? (
      <UnavailableValue message={FUTURE_SALES_MESSAGE} />
      )
    : renderValue()

  return (
    <Grid item lg={3} sm={6} xl={3} xs={12}>
      <Card
        onClick={() => handleSelectStore(store._id)}
        key={String(store._id)}
        className={clsx(classes.root, classes.card)}
      >
        <CardContent className={classes.container}>
          <Avatar
            alt={store.name}
            className={classes.avatar}
            src={store.photo.url}
          />
          <Typography variant='h5' component='h2'>
            {store.name}
          </Typography>
          {/* <Typography
              className={classes.pos}
              color='textSecondary'
            >
              {store.city}
          </Typography> */}
          <Divider />

          <List>
            <ListItem>
              <ListItemAvatar>
                <Avatar style={{
                    background: salesDisabled
                    ? '#9e9e9e'
                    : '#2ecc71'
                }}>
                  <LoyaltyIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary='Peças vendidas'
                secondary={renderSalesValue(() => store.total.items)}
              />
            </ListItem>
            <ListItem>
              <ListItemAvatar>
                <Avatar style={{
                    background: salesDisabled
                    ? '#9e9e9e'
                    : '#2ecc71'
                }}>
                  <ShoppingCartIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary='Quantidade de vendas'
                secondary={renderSalesValue(() => store.total.sales)}
              />
            </ListItem>
            <ListItem>
              <ListItemAvatar>
                <Avatar style={{
                  background: salesDisabled ? '#9e9e9e' : '#2ecc71'
                }}>
                  <AttachMoneyIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary='Faturamento'
                secondary={renderSalesValue(() => formatPrice(store.total.sold))}
              />
            </ListItem>
            <ListItem>
              <ListItemAvatar>
                <Avatar style={{
                  background: isFieldDisabled(projectionSoldReason)
                    ? '#9e9e9e'
                    : '#2ecc71'
                }}>
                  <TimelineIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary='Projeção'
                secondary={isFieldDisabled(projectionSoldReason)
                  ? (
                    <UnavailableValue
                      message={getDisabledFieldMessage(projectionSoldReason)}
                    />
                    )
                  : formatPrice(store.projection.sold)}
              />
            </ListItem>
            <ListItem>
              <ListItemAvatar>
                <Avatar style={{
                  background: salesDisabled || isFieldDisabled(mainGoalReason)
                    ? '#9e9e9e'
                    : '#2ecc71'
                }}>
                  <InsertChartIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary='Percentual da meta'
                secondary={salesDisabled || isFieldDisabled(mainGoalReason)
                  ? (
                    <UnavailableValue
                      message={salesDisabled
                        ? FUTURE_SALES_MESSAGE
                        : getDisabledFieldMessage(mainGoalReason)}
                    />
                    )
                  : formatToPercentage(
                    safeDivision(store.total.sold, store.metric.mainGoal) * 100
                  )}
              />
            </ListItem>
          </List>
        </CardContent>
      </Card>
    </Grid>
  )
}
